// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"d1e31152","453":"a6a41944"}[chunkId] + ".chunk.js";
};